import * as React from 'react';
import { Route } from 'react-router';

import CollectionsApp from 'bundles/collections/components/CollectionsApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const CollectionPage = loadOnRoute(() => import('bundles/collections/components/CollectionPage'));

export default (
  <Route path="/" component={CollectionsApp}>
    <Route path="collections/:slug" getComponent={CollectionPage} />
    <Route path="*" component={NotFound} />
  </Route>
);
